export const MISTYPED_TOP_LEVEL_DOMAIN_MAP = {
  com: [
    'co', 'con', 'comm', 'vom', 'cim', 'coml', 'coms', 'comj', 'clm',
    'coma', 'cok', 'comn', 'xom', 'comb', 'comi', 'col', 'comc', 'comt',
    'comr', 'cm', 'comk', 'gom', 'comd', 'comg', 'cpm', 'comp', 'comh',
    'comf', 'om', 'ckm', 'comy', 'comv', 'como'
  ],
}

export const MISTYPED_SECOND_LEVEL_DOMAIN_MAP = {
  gmail: ['gnail', 'fmail', 'tmail', 'hmail', 'vmail', 'bmail', 'ymail'],
}
